import {
    CabinetTransform,
    updateCabinetPosition,
} from 'components/customer/RoomPlanner/store/roomPlannerSlice';
import {CabinetMesh} from 'components/customer/RoomPlanner/types';
import {store} from 'store/customer';

type Axis = 'x' | 'z' | 'y';

/**
 * Resets a cabinet's position to its previously stored coordinates.
 *
 * @param {CabinetMesh} product - The cabinet mesh being modified.
 * @param {CabinetTransform[]} oldCabinets - Collection of stored cabinet positions.
 * @param {Axis} [axis] - Optional axis to reset. If omitted, both axes are reset.
 * @return {void}
 */
export function resetCabinetPosition(
    product: CabinetMesh,
    oldCabinets: CabinetTransform[],
    axis?: Axis
): void {
    const id = Number(product.userData?.values?.id ?? 0);
    if (!id) return;

    const dupId = product.userData?.values?.duplicate_id;
    const oldCabinet = oldCabinets.find((cab) => String(cab.id) === dupId);
    if (!oldCabinet) return;

    if (axis === 'x') {
        product.position.x = oldCabinet.position.x;
    } else if (axis === 'z') {
        product.position.z = oldCabinet.position.z;
    } else if (axis !== 'y') {
        product.position.x = oldCabinet.position.x;
        product.position.z = oldCabinet.position.z;
    }

    let index = 0;
    const rawId = product.userData?.id;
    if (typeof rawId === 'string' || typeof rawId === 'number') {
        const [, extracted] = String(rawId).split('-');
        index = Number(extracted) || 0;
    }

    store.dispatch(
        updateCabinetPosition({
            rotation: product.rotation,
            position: product.position,
            id,
            index,
        })
    );
}
